const successMsgs = {
  changePassword: "Password is changed successfully",
  forgetPassword: "We have sent you a new password",
  deletedSuccessfully: "Successfully deleted",
  addedSuccessfully: "Added successfully",
  editedSuccessfully: "Edited successfully",
  generatedSuccessfully: "Generated successfully",
  copiedSuccessfully: "Copied Successfully",
  cancelledSuccessfully: "Cancelled successfully",
  settledSuccessfully:"Settled successfully",
  blockedSuccessfully: "Customer is blocked successfully",
  unblockedSuccessfully: "Customer is unblocked successfully",
  resolvedSuccessfully: "Resolved successfully",
  exportTransactions: "Payment transactions report email sent",
  exportSettlements: "Settlements report email sent",
  exportSingleSettlement: "Settlement items report email sent"
};

export default successMsgs;
